import * as React from 'react'
import { GastroCardDetails } from '@models/promotions'
import { Button } from 'reactstrap'
import { useAppDispatch } from '@store/index'
import { UserPermission } from '@models/dashboard'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { commonObjectDelete } from '@store/actions/generic-actions'
import { useNotificationHook } from '@hyper/use-notification-hook'
import { updateGastroCardDetails } from '@store/slices/gastro-card-slice'
import { CommonObjectConfirmAction } from '@components/common-objects-confirm-action'
import { useApiRequest } from '@components/hooks/use-api-request'

interface GastroCardDetailsDeleteProps {
  gastroCardDetails: GastroCardDetails
  onDelete: () => void
}

export const GastroCardDetailsDelete: React.FC<GastroCardDetailsDeleteProps> = ({ gastroCardDetails, onDelete }) => {
  const dispatch = useAppDispatch()
  const { addSuccessMessage } = useNotificationHook()

  const user = useAuthenticatedUser()

  const { isLoading, action: handleAccept } = useApiRequest(async (reason: string) => {
    dispatch(
      updateGastroCardDetails(await commonObjectDelete<GastroCardDetails>(gastroCardDetails.urls.details, reason)),
    )
    addSuccessMessage('Sukces', 'Voucher Gastro został skasowany!')
    onDelete()
  })

  const canDelete = user.hasPerm(UserPermission.PromotionsGastroCardCanDelete) && !gastroCardDetails.is_removed

  return canDelete ? (
    <CommonObjectConfirmAction isLoading={isLoading} handleAccept={handleAccept} askForReason={true}>
      <Button className="btn-light btn" type="button">
        <i className="uil uil-trash-alt cursor-pointer" title="Skasuj" />
        Usuń
      </Button>
    </CommonObjectConfirmAction>
  ) : null
}
